import VConsole from 'vconsole';
import config from 'config';
const vc = config.vconsole.enabled ? new VConsole() : {};

export default vc;
